import base64 from 'base64-js';
import { TextEncoder } from 'text-encoding-shim';

const base64Encode = (str) => {
  const bytes = new TextEncoder().encode(str);
  return base64.fromByteArray(bytes);
};

export default base64Encode;
